import React from 'react';
import { compose, lifecycle } from 'recompose';
import { applicationEnhancer } from "./enhancer";
import { ProgressIndicator } from '@applyboard/crystal-ui';
var enhancer = compose(applicationEnhancer, lifecycle({
  componentWillMount: function componentWillMount() {
    this.props.init(this.props.applicationId, this.props.permissions);
  }
}));
export var ApplicationDataLoader = enhancer(function ApplicationDataLoader(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
});
export var WaitForApplicationData = applicationEnhancer(function WaitForApplicationData(_ref2) {
  var loading = _ref2.loading,
    application = _ref2.application,
    children = _ref2.children;
  if (!application || loading) {
    return /*#__PURE__*/React.createElement(ProgressIndicator, {
      indeterminate: true,
      variant: "circular",
      "aria-label": "Loading..."
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
});